<template>
  <div class="class-picker">
    <div class="choose-text"><div class="choose-title">{{ $t('class_picker.current_class') }}:</div><div>{{ getChooseCategoryText }}</div></div>
    <label class="btn btn-orange" for="menu-controller" @click="menuOpen=true">{{ $t('class_picker.choose_class') }}</label>
    <input type="checkbox" id="menu-controller">
    <div class="picker-hover" :class="{ active: menuOpen }" @click="menuOpen =false"></div>
    <div class="picker-menu-block" :class="{ active: menuOpen }">
       <div v-for="(item,key,index) in list" :key="index+'_title'" class="picker-group">
        <div class="group-title"><span>{{ key }}</span></div>
        <div class="group-item-block">
          <router-link
            :to="{name: pagename,query:{category:item1.id}}"
            v-for="(item1,key1,index1) in item" 
            :key="key1+index1" 
            class="group-item"
            :class="{ active: category==item1.id }"
            :id="'picker_item_'+item1.id"
          >
            {{ item1.name }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'class-picker',
    props: ['list','pagename'],
    data() {
      return {
        category: '',
        menuOpen: false
      }
    },
    computed: {
      getChooseCategoryText() {
        let cateTitle = '';
        let itemTitle = '';
        if(this.category && this.list) {
          for (const key in this.list) {
            if (this.list.hasOwnProperty(key)) {
              const element = this.list[key];
              for (const key2 in element) {
                if (element.hasOwnProperty(key2)) {
                  const element2 = element[key2];
                  if(element2.id==this.category) {
                    cateTitle = key;
                    itemTitle = element2.name;
                  }
                }
              }
            }
          }
        }
        return `${cateTitle}/${itemTitle}`;
      }
    },
    created(){
      this.category = this.$route.query.category || '';      
    },
    mounted() {
      // setTimeout(() => {
      //   if(this.category) {
      //     const chooseItem = document.querySelector(`#picker_item_${this.category}`);
      //     const picker = document.querySelector(`.class-picker`);
      //     picker.scrollLeft = chooseItem.offsetLeft-50;
      //   } else {
      //     console.log('no category');
      //   }
      // }, 500);
    }
  }
</script>

<style lang="less" scoped>
.class-picker {
  width: 100%;
  // background: grey;
  display: flex;
  align-items: center;
  overflow: scroll;
  margin-bottom: 20px;
  margin-top: -10px;
  // -ms-overflow-style: none;
  // &::-webkit-scrollbar {
  //   display: none;
  // }
  // .picker-group {
  //   display: flex;
  //   .group-title {
  //     word-break: keep-all;
  //     padding: 5px 20px;
  //     background: #ec4f00;
  //     color: white;
  //     border-top-left-radius: 5px;
  //     border-top-right-radius: 5px;
  //   }
  //   .group-item {
  //     word-break: keep-all;
  //     padding: 5px 20px;
  //     color: grey;
  //     text-decoration: none;
  //     &.active {
  //       color: #ec4f00;
  //     }
  //   }
  // }
  .choose-text {
    display: flex;
    .choose-title {
      word-break: keep-all;
      margin-right: 5px;
    }
  }
  .btn-orange {
    padding: 5px 10px;
    margin-left: 10px;
    word-break: keep-all;
  }
  .picker-hover {
      position: fixed;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.6);
      top: 0;
      left: 0;
      z-index: 100;
      display: none;
      &.active {
        display: block;
      }
  }
  .picker-menu-block {
    position: fixed;
    width: 100%;
    height: 80%;
    background: white;
    bottom: 0;
    left: 0;
    z-index: 100;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 20px;
    transform: translateY(101%);
    transition: .5s;
    &.active {
      transform: translateY(0);
    }
    .picker-group {
      margin-bottom: 15px;
      border-bottom: 1px solid #bbb;
      .group-title {
        margin-bottom: 10px;
        span {
          background: #ec4f00;
          color: white;
          padding: 5px 10px;
          line-height: 30px;
        }
      }
      .group-item-block {
        display: flex;
        flex-wrap: wrap;
      }
      .group-item {
        width: 100px;
        text-decoration: unset;
        color: black;
        margin-bottom: 15px;
        &.active {
          color: #ec4f00;
        }
      }
    }
  }
}
</style>